export const CUSTOMER_FIELD_ERRORS = {
  name: 'Please enter your full name (at least 2 words).',
  email: 'Please enter a valid email address.',
  phone: 'Phone number must start with country code, e.g. +20109878708.',
};

function cleanText(value) {
  return typeof value === 'string' ? value.trim().replace(/\s+/g, ' ') : '';
}

export function normalizeCustomerDetails(contact = {}) {
  return {
    name: cleanText(contact.name),
    email: cleanText(contact.email).toLowerCase(),
    phone: cleanText(contact.phone).replace(/\s/g, ''),
  };
}

export function isValidFullName(value) {
  const name = cleanText(value);
  return name.length >= 3 && name.split(' ').length >= 2 && /\p{L}/u.test(name);
}

export function isValidEmail(value) {
  const email = cleanText(value).toLowerCase();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function isValidPhone(value) {
  const phone = cleanText(value).replace(/\s/g, '');
  return /^\+[1-9]\d{7,14}$/.test(phone);
}

export function validateCustomerDetails(contact) {
  const normalized = normalizeCustomerDetails(contact);
  const errors = {};

  if (!isValidFullName(normalized.name)) errors.name = CUSTOMER_FIELD_ERRORS.name;
  if (!isValidEmail(normalized.email)) errors.email = CUSTOMER_FIELD_ERRORS.email;
  if (!isValidPhone(normalized.phone)) errors.phone = CUSTOMER_FIELD_ERRORS.phone;

  return {
    errors,
    isValid: Object.keys(errors).length === 0,
    normalized,
  };
}
